import 'Styles/templates/page.boutique.scss'
import $ from 'cash-dom'

function loadScript(src, callback) {
  var script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = src
  script.onload = callback
  document.body.appendChild(script)
}

document.addEventListener('DOMContentLoaded', () => {
  const boutiqueMap = document.querySelector('.boutique-map')
  const markUrl = boutiqueMap.dataset.markUrl;
  const key = 'AIzaSyAW4FC0dQ5azNz5JGZoXHkcu0vQ5_GJPuE';

  if (boutiqueMap) {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${key}` ,
      function () {
        // init map
        const map = new google.maps.Map(boutiqueMap, {
          center: { lat: 41.46331, lng: -81.915436 },
          zoom: 10,
          disableDefaultUI: true,
          // styles gray scale map
          styles: [
            {
              featureType: 'all',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e9e9e9',
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#000000',
                },
              ],
            },
            {
              featureType: 'all',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.country',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#7f7f7f',
                },
              ],
            },
            {
              featureType: 'administrative.country',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'administrative.province',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#7f7f7f',
                },
              ],
            },
            {
              featureType: 'administrative.province',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'administrative.locality',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#7f7f7f',
                },
              ],
            },
            {
              featureType: 'administrative.locality',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'administrative.neighborhood',
              elementType: 'geometry',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#7f7f7f',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.neighborhood',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#000000',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'transit',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e9e9e9',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#c9c9c9',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#000000',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
          ],
        })

        // init markers
        const markers = [
          {
            position: { lat: 41.46331, lng: -81.915436 },
            title: 'Cleveland',
            icon: {
              url: markUrl,
              scaledSize: new google.maps.Size(30, 40),
            },
          },
        ]

        // add markers to map
        markers.forEach((marker) => {
          new google.maps.Marker({
            position: marker.position,
            map,
            title: marker.title,
            icon: marker.icon,
          })
        })
      }
    )
  }
})
